import HeaderLayout from '../../../layouts/Header'
import { useNav, useParseQuery } from '../../../hooks/useNav'

import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import Select from '../../../components/function/filters/Select'
import Date from '../../../components/function/filters/Date'
import DropDownList from '../../../components/function/filters/DropDownList'
import SearchHeader from '../../../components/function/filters/SearchHeader'
import { PATH } from '../../../data/router_path'
import {
  addDefaultDropDown,
  convertFilterDateFormat,
} from '../../../utils/conversion'
import { showErrorToast } from '../../../utils/showToast'
import useGetBookCollection from './hooks/useGetBookCollection'
import { useEffect } from 'react'
import { BOOKS_PACKAGE_STORAGE_KEY } from '../../../data/constants'
import { getCurrentTimeKey } from '../../../utils/book_common'
import { FaLongArrowAltLeft } from 'react-icons/fa'
import {useLocation} from 'react-router-dom'
const bookFilterSchema = z.object({
  keywords: z.string().nullable().optional(),
  all_radio: z.boolean().nullable().optional(),
  date_fixed_radio: z.boolean().nullable().optional(),
  date_fixed: z.string().nullable().optional(),
  date_range_radio: z.boolean().nullable().optional(),
  date_from: z.string().nullable().optional(),
  date_to: z.string().nullable().optional(),
  book_collection_uuid: z.string().optional().nullable(),
})

export default function BookFilterHeader({
  title,
  path,
  BookPackageFilterDisplay = true,
  titleBookBorrow,
}) {
    const location = useLocation()
    const arrLocation = location.pathname.split('/')
   const isPageBookBorrow =arrLocation[1]
  const navigate = useNav()
  const { queryParams } = useParseQuery()
  const { control, handleSubmit, setValue, watch } = useForm({
    resolver: zodResolver(bookFilterSchema),
    defaultValues: {
      keywords: '',
      all_radio: true,
      date_fixed_radio: false,
      date_fixed: undefined,
      date_range_radio: false,
      date_from: undefined,
      date_to: undefined,
      book_collection_uuid: undefined,
    },
  })
  const [all_radio, book_collection_uuid] = watch([
    'all_radio',
    'book_collection_uuid',
  ])

  const searchHandler = (formValue) => {
    const {
      all_radio,
      date_fixed_radio,
      date_range_radio,
      keywords,
      date_fixed,
      date_from,
      date_to,
      book_collection_uuid,
    } = formValue
    let filters = {
      ...queryParams,
      keywords,
      book_collection_uuid,
      pageNumber: 0,
    }
    if (all_radio) {
      filters.createdAt = undefined
    }
    if (date_fixed_radio) {
      if (!date_fixed) {
        showErrorToast({
          message: 'Vui lòng chọn ngày cụ thể',
        })
        return
      }
      filters.createdAt = `${convertFilterDateFormat(date_fixed)}-${convertFilterDateFormat(date_fixed)}`
    } else if (date_range_radio) {
      if (!date_from || !date_to) {
        showErrorToast({
          message: 'Vui lòng chọn đủ khoảng ngày',
        })
        return
      }
      filters.createdAt = `${convertFilterDateFormat(date_from)}-${convertFilterDateFormat(date_to)}`
    }

    navigate(path, { params: filters })
  }
  useEffect(() => {
    handleSubmit(searchHandler)()
  }, [book_collection_uuid])
  useEffect(() => {
    // To only get previous book collection in the past 1 minute
    const savedDataString = localStorage.getItem(
      BOOKS_PACKAGE_STORAGE_KEY.BOOK_PACKAGE_UUID
    )

    if (!savedDataString) {
      localStorage.removeItem(BOOKS_PACKAGE_STORAGE_KEY.BOOK_PACKAGE_UUID)
      return
    }

    const savedData = JSON.parse(savedDataString)
    const currentTimeKey = getCurrentTimeKey()

    if (savedData.time !== currentTimeKey) {
      localStorage.removeItem(BOOKS_PACKAGE_STORAGE_KEY.BOOK_PACKAGE_UUID)
      return
    }
    setValue('book_collection_uuid', savedData?.uuid)
  }, [])
  useEffect(() => {
    if (all_radio) {
      handleSubmit(searchHandler)()
    }
  }, [all_radio])
  const handleRadioChange = (selectedName, newValue) => {
    if (newValue) {
      setValue('all_radio', selectedName === 'all_radio')
      setValue('date_fixed_radio', selectedName === 'date_fixed_radio')
      setValue('date_range_radio', selectedName === 'date_range_radio')
    } else {
      setValue('all_radio', true)
      setValue('date_fixed_radio', false)
      setValue('date_range_radio', false)
    }
  }
  const { data } = useGetBookCollection()
  const isBorrow = localStorage.getItem('isBorrow')
  return (
    <HeaderLayout>
      {titleBookBorrow ? (
        <div className="relative flex gap-2">
          <button
            onClick={() => {
              navigate(PATH.BOOK.BORROW)
            }}
            className="absolute top-3"
          >
            <FaLongArrowAltLeft size={30} />
          </button>
          <p className="ml-12 pl-0.5 text-xl">{titleBookBorrow}</p>
        </div>
      ) : null}
      <form
        onSubmit={handleSubmit(searchHandler)}
        className={'flex flex-col justify-center gap-4'}
      >
        <SearchHeader
          title={title}
          placeholder="Tìm kiếm nhan đề sách, tên tác giả..."
          control={control}
          name={'keywords'}
        />
        {isPageBookBorrow==='book-borrow'? null :<div className="flex items-center justify-between gap-4 text-base font-semibold">
          <Select
            control={control}
            name={'all_radio'}
            title={'Tất cả'}
            onChangeHandler={handleRadioChange}
          />
          <div className="flex items-center">
            <Select
              control={control}
              name={'date_fixed_radio'}
              onChangeHandler={handleRadioChange}
            />
            <Date control={control} name={'date_fixed'} title={'Ngày'} />
          </div>
          <div className="flex items-center">
            <Select
              control={control}
              name={'date_range_radio'}
              onChangeHandler={handleRadioChange}
            />

            <div className="flex items-center gap-3">
              <Date control={control} name={'date_from'} title={'Từ'} />
              <Date control={control} name={'date_to'} title={'Đến'} />
            </div>
          </div>
          {BookPackageFilterDisplay && !isBorrow && !titleBookBorrow && (
            <DropDownList
              control={control}
              name={'book_collection_uuid'}
              title={'Gói sách'}
              options={addDefaultDropDown(
                (data?.collections ?? [])?.map((item) => ({
                  value: item?.uuid,
                  label: item?.name,
                }))
              )}
            />
          )}
        </div>}
      </form>
    </HeaderLayout>
  )
}
